import type { FactoryIntegration, FactoryIntegrationUpdate, FactorySettingScalar } from "@/core/models/factory-integration-settings.model";

export function initialIntegrationValues(item: FactoryIntegration): Record<string, FactorySettingScalar | undefined> {
  const values: Record<string, FactorySettingScalar | undefined> = {};
  item.fields.forEach(field => { values[field.key] = field.type === "secret" ? "" : item.values[field.key]; });
  return values;
}

export function integrationUpdate(item: FactoryIntegration, input: Record<string, unknown>, clear: string[]): FactoryIntegrationUpdate {
  const values: Record<string, FactorySettingScalar> = {};
  const clearSecrets = clear.filter(key => item.fields.some(field => field.key === key && field.type === "secret"));
  item.fields.forEach(field => {
    const value = input[field.key];
    if (clearSecrets.includes(field.key)) values[field.key] = "";
    else if (field.type === "secret") values[field.key] = typeof value === "string" ? value : "";
    else if (typeof value === "string" || typeof value === "boolean" || (typeof value === "number" && Number.isFinite(value))) values[field.key] = value;
  });
  return { revision: item.revision, values, clearSecrets };
}
